import { getDefaultDBEntityDocument, } from "utils-library/dist/db-entity-interfaces";
export const getDefaultRegion = () => getDefaultDBEntityDocument({
    order: -1,
    label: '',
    description: '',
    notes: '',
});
